module.exports = __webpack_public_path__ + "static/media/estonia-bg.a0b22d3c.png";